import type {Prompt} from '@cp/model';
import {useCallback, useState} from 'react';
import {promptsGenerateQuestionWithSeed} from '../../api/callable/prompts';

export interface GenerateQuestionWithSeedPromptsVariables {
  moduleId: string;
  topic?: string;
  seedQuestionId: string;
  numberOfVariants?: number;
  additionalInfo?: string;
}

export function useGenerateQuestionWithSeedPrompts() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const generateQuestionWithSeedPrompts = useCallback(
    async (variables: GenerateQuestionWithSeedPromptsVariables): Promise<Prompt> => {
      if (typeof variables.numberOfVariants !== 'number') {
        throw new Error('numberOfVariants is required');
      }
      setLoading(true);
      setError(undefined);
      try {
        return await promptsGenerateQuestionWithSeed({
          moduleId: variables.moduleId,
          seedQuestionId: variables.seedQuestionId,
          numberOfVariants: variables.numberOfVariants,
        });
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    generateQuestionWithSeedPrompts,
    loading,
    error,
  };
}
